
import { reactive } from "vue";
import Loading from "vue3-loading-overlay/dist/index";
import "vue3-loading-overlay/dist/vue3-loading-overlay.css"

export default {
  setup() {
    const viewmodel = reactive({
      isLoading: false,
      fullPage: true,
      canCancel: true,
      useSlot: false,
      loader: "spinner",
      color: "#007bff",
      bgColor: "#ffffff",
      height: 128,
      width: 128,
      timeout: 3000,
    });

    const simulate = () => {
      viewmodel.isLoading = true;
      // Simulate async call
      setTimeout(() => {
        viewmodel.isLoading = false;
      }, viewmodel.timeout);
    };

    const whenCancelled = () => {
      console.log("User cancelled the loader.");
      viewmodel.isLoading = false;
    };
    return {
      viewmodel,
      simulate,
      whenCancelled,
    };
  },

  components: {
    Loading,
  }
};
